import React from 'react';
import './resumo.scss';

//Componentes
import Label from '../../components/label';
import Breadcrumbs from '../../components/breadcrumbs';
import NavigationButtons from '../../components/navigationButtons';
import Checks from '../../components/checks';
import CheckObligation from '../../components/checkObligation';
import { Redirect } from 'react-router-dom';
import loadingImg from '../../assets/images/loading-white.svg'
import CheckBox from '../../components/checkBox';


class Resumo extends React.Component {

  componentWillMount() {
    this.formFields = []
    const {
      getListRendaMensalAction,
      getListPatrimonioAction,
      getListDeclaracaoAnualAction,
    } = this.props;
    getListRendaMensalAction();
    getListPatrimonioAction();
    getListDeclaracaoAnualAction();
  }

  render() {

    let {
      dadosIniciais_tipoDocumento,
      dadosIniciais_paisDocumento,
      dropdownDocumentoList,
      dadosIniciais_orgaoEmissor,
      dropdownOrgaoEmissorList
    } = this.props;

    let {
      endereco_estado,
      endereco_pais,
      typeaHeadEnderecoEstadoList
    } = this.props;

    let {      
      tipoPessoaValue
    } = this.props;

    let {
      dadosComplementares_estadoCivil,
      dadosComplementares_pessoaAmericana,
      dadosComplementares_PaisNascimento,
      dadosComplementares_paisFiscal,
      dropdownDadosEstadoCivilList,
    } = this.props;

    let {
      declaracoesEspecificasObrigatorias_ppe,
      declaracoesEspecificasObrigatorias_relacaoPessoaPpe,
      declaracoesEspecificasObrigatorias_socioPpe,
      declaracoesEspecificasObrigatorias_participanteFatca,
      declaracoesEspecificasObrigatorias_pessoaAmericana,
      declaracoesEspecificasObrigatorias_faixaRendaMensal,
      declaracoesEspecificasObrigatorias_faixaPatrimonio,
      declaracoesEspecificasObrigatorias_declaracaoAnual
    } = this.props;

    let {
      documentos_documentoIdentificacaoFrente,
      documentos_documentoIdentificacaoVerso,
      documentos_comprovanteResidenciaComprovante,
      documentos_comprovanteRendaComprovante,
      documentos_procuracaoComprovante,
      documentos_contratoSocialComprovante,
      documentos_balancoPatrimonial,
      documentos_faturamentoUltimosMeses,
      documentosSocioDezOuMais,
      documentos_estatutoPessoaJuridicaNacional,
      documentos_procuracaoPessoaJuridicaEstrangeira,
    } = this.props;

    let {
      dadosBancarios_Banco,
      dadosBancarios_TipoConta,
    } = this.props.dadosBancario.formDadosBancarios;

    const {
      dropdownBancoList,
      dropdownTipoContaList
    } = this.props.dadosBancario;

    const {
      dropdownDadosRendaMensalList,
      dropdownDadosPatrimonioList,
    } = this.props.rendaPatrimonio;

    const {
      dropdownDeclaracaoAnualList,
    } = this.props.declaracaoEspecifica;
  
    let {
      loadingResumoUpload,
      resumo_check1,
      resumo_check2
    } = this.props.resumo;

    let {
      listPais
    } = this.props.ddi;

    let { postObjCadastroResumoAction, handleChangeCheckBox1, handleChangeCheckBox2 } = this.props;

    let { Grupos } = this.props.navigation.currentNavegation

    let existeDadosComplementares = Grupos.filter(function (el) {
      return el.URL === "/dadosComplementares";
    });

    let existeDeclaracoesEspecificas = Grupos.filter(function (el) {
      return el.URL === "/declaracoesEspecificas";
    });

    let existeDadosBancarios = Grupos.filter(function (el) {
      return el.URL === "/dadosBancarios";
    });

    let endereco_paisResult = listPais.filter(function (el) {
      return el.IdPais === endereco_pais;
    });
    let endereco_paisNome = endereco_paisResult.length > 0 ? endereco_paisResult[0].Nome : "";

    let endereco_estadoResult = typeaHeadEnderecoEstadoList.filter(function (el) {
      return el.IdEstado === endereco_estado;
    });
    let endereco_estadoNome = endereco_estadoResult.length > 0 ? endereco_estadoResult[0].Nome : "";

    let dadosIniciais_paisDocumentoResult = listPais.filter(function (el) {
      return el.IdPais === dadosIniciais_paisDocumento;
    });
    let dadosIniciais_paisDocumentoNome = dadosIniciais_paisDocumentoResult.length > 0 ? dadosIniciais_paisDocumentoResult[0].Nome : "";

    let dadosComplementares_PaisNascimentoResult = listPais.filter(function (el) {
      return el.IdPais === dadosComplementares_PaisNascimento;
    });
    let dadosComplementares_PaisNascimentoNome = dadosComplementares_PaisNascimentoResult.length > 0 ? dadosComplementares_PaisNascimentoResult[0].Nome : "";

    let dadosComplementares_PaisFiscalResult = listPais.filter(function (el) {
      return el.IdPais === dadosComplementares_paisFiscal;
    });
    let dadosComplementares_PaisFiscalNome = dadosComplementares_PaisFiscalResult.length > 0 ? dadosComplementares_PaisFiscalResult[0].Nome : "";

    let dadosIniciais_tipoDocumentoResult = dropdownDocumentoList.filter(function (el) {
      return el.value.toString() === dadosIniciais_tipoDocumento;
    });
    let dadosIniciais_tipoDocumentoNome = dadosIniciais_tipoDocumentoResult.length > 0 ? dadosIniciais_tipoDocumentoResult[0].name : "";

    let dadosIniciais_orgaoEmissorResult = dropdownOrgaoEmissorList.filter(function (el) {
      return el.value === dadosIniciais_orgaoEmissor;
    });
    let dadosIniciais_orgaoEmissorNome = dadosIniciais_orgaoEmissorResult.length > 0 ? dadosIniciais_orgaoEmissorResult[0].name : "";

    let dadosComplementares_EstadoCivilListResult = dropdownDadosEstadoCivilList.filter(function (el) {
      return el.value.toString() === dadosComplementares_estadoCivil;
    });
    let dadosComplementares_EstadoCivilListNome = dadosComplementares_EstadoCivilListResult.length > 0 ? dadosComplementares_EstadoCivilListResult[0].name : "";

    // let dadosComplementares_GeneroListResult = dropdownDadosGeneroList.filter(function (el) {
    //   return el.value.toString() === dadosComplementares_genero;
    // });
    // let dadosComplementares_GeneroListNome = dadosComplementares_GeneroListResult.length > 0 ? dadosComplementares_GeneroListResult[0].name : "";

    let dadosBancario_BancoListResult = dropdownBancoList.filter(function (el) {
      return el.CodigoBanco === dadosBancarios_Banco;
    });
    let dadosBancario_BancoListNome = dadosBancario_BancoListResult.length > 0 ? dadosBancario_BancoListResult[0].Nome : "";

    let dadosBancario_TipoContaListResult = dropdownTipoContaList.filter(function (el) {
      return el.value.toString() === dadosBancarios_TipoConta;
    })
    let dadosBancario_TipoContaListNome = dadosBancario_TipoContaListResult.length > 0 ? dadosBancario_TipoContaListResult[0].name : "";

    let declaracoesEspecificas_rendaMensalResult = dropdownDadosRendaMensalList.find(function (el) {
      return el.value === Number(declaracoesEspecificasObrigatorias_faixaRendaMensal);
    });
    if (declaracoesEspecificas_rendaMensalResult)
      var declaracoesEspecificasObrigatorias_rendaMensalRotulo = declaracoesEspecificas_rendaMensalResult.name;

    let declaracoesEspecificas_patrimonioResult = dropdownDadosPatrimonioList.find(function (el) {
      return el.value === Number(declaracoesEspecificasObrigatorias_faixaPatrimonio);
    });
    if (declaracoesEspecificas_patrimonioResult)
      var declaracoesEspecificasObrigatorias_patrimonioRotulo = declaracoesEspecificas_patrimonioResult.name;
      
    let declaracoesEspecificas_declaracaoAnualResult = dropdownDeclaracaoAnualList.find(function (el) {
      return el.value === Number(declaracoesEspecificasObrigatorias_declaracaoAnual);
    });
    if (declaracoesEspecificas_declaracaoAnualResult)
      var declaracoesEspecificas_declaracaoAnualRotulo = declaracoesEspecificas_declaracaoAnualResult.name;
  
    let itensChecados = [];

    if (documentos_documentoIdentificacaoFrente.IdDocumentoArquivo)
      itensChecados.push({ name: 'documentos_documentoIdentificacaoFrente', id: 0, value: 'Frente do documento de identificação com foto e CPF (RG, CNH, documento de orgão de classe - dentro do prazo de validade)' });

    if (documentos_documentoIdentificacaoVerso.IdDocumentoArquivo)
      itensChecados.push({ name: 'documentos_documentoIdentificacaoVerso', id: 1, value: 'Verso do documento de identificação e CPF (RG, CNH, documentos de órgão de classe – dentro do prazo de validade).' });

    if (documentos_comprovanteResidenciaComprovante.IdDocumentoArquivo)
      itensChecados.push({ name: 'documentos_comprovanteResidenciaComprovante', id: 2, value: 'Comprovante de residência em nome do cliente (conta de consumo – água, luz, telefone fixo ou gás, emitido nos últimos 90 dias).' });

    if (documentos_comprovanteRendaComprovante.IdDocumentoArquivo)
      itensChecados.push({ name: 'documentos_comprovanteRendaComprovante', id: 3, value: 'Comprovante de renda (IRPF do último ano base, últimos 3 contracheques ou DECORE emitido pelo contador).' });

    if (documentos_procuracaoComprovante.IdDocumentoArquivo)
      itensChecados.push({ name: 'documentos_procuracaoComprovante', id: 4, value: tipoPessoaValue==="PessoaJuridica"?'Procuração concedendo poderes para executar operações de câmbio em nome do cliente com firma reconhecida' :'Procuração com firma reconhecida.' });

    if (documentos_contratoSocialComprovante.IdDocumentoArquivo)
      itensChecados.push({ name: 'documentos_contratoSocialComprovante', id: 5, value: 'Estatuto ou Contrato Social e/ou da última Alteração Contratual Consolidada.' });

    if (documentos_balancoPatrimonial.IdDocumentoArquivo)
      itensChecados.push({ name: 'documentos_balancoPatrimonial', id: 7, value: 'Último Balanço Patrimonial assinado pelo contador e pelo responsável pela empresa ou DEFIS (Somente para empresas caraterizadas Simples Nacional) ou Escrituração Contábil Fiscal (ECF) e Recibo de Entrega (Somente para empresas na categoria de Lucro Presumido ou Real).' });

    if (documentos_faturamentoUltimosMeses.IdDocumentoArquivo)
      itensChecados.push({ name: 'documentos_faturamentoUltimosMeses', id: 8, value: 'Faturamento dos últimos 12 meses assinado pelo contador e pelo responsável pela empresa.' });

    documentosSocioDezOuMais.map((x, index) => {
      if (x.documentos_comprovanteRendaSocioPessoaFisicaDezOuMais.IdDocumentoArquivo)
        itensChecados.push({ name: 'documentos_comprovanteRendaSocioPessoaFisicaDezOuMais', id: 16, value: `Comprovante de renda atualizado Sócio ${index + 1} (IRPF do último ano base, últimos 3 contracheques ou DECORE emitido pelo contador) - Aplicável somente para empresas recém constituídas ou que operam com importação na posição própia da B&T` });
      return x;
    }) 

    if (documentos_estatutoPessoaJuridicaNacional.IdDocumentoArquivo)
      itensChecados.push({ name: 'documentos_estatutoPessoaJuridicaNacional', id: 19, value: 'Estatuto ou Contrato Social e/ou da última Alteração Contratual Consolidada do Sócio Pessoa Jurídica Nacional.' })

    if (documentos_procuracaoPessoaJuridicaEstrangeira.IdDocumentoArquivo)
      itensChecados.push({ name: 'documentos_procuracaoPessoaJuridicaEstrangeira', id: 20, value: 'Procuração outorgada ao representante legal no Brasil do Sócio Pessoa Jurídica Estrangeira.' })

    return (
      <section className="container">
        <div className="col" >
          <Breadcrumbs />
        </div>
        {/* ============================== Objetivo do cadastro: =================================== */}
        <div className="col">
          <Label type="title" label="Objetivo do cadastro" />
        </div>

        <div className="col">
          <Label type="" label="" value={this.props.tipoContrato} returnObject={this.createRefFields} />
        </div>

        <CheckObligation field="maisDetalhes_field" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col">
              <Label type="" label="" value={this.props.maisDetalhes_field} returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>

        {/* ============================== Dados Iniciais PF ===================================*/}
        <div className="col">
          <Label type="title" label="Dados Iniciais" />
        </div>
        <CheckObligation field="dadosIniciais_codigoGerente" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col">
              <Label type="" label="Código do gerente" value={this.props.dadosIniciais_codigoGerente} returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>
        <CheckObligation field="dadosIniciais_nomeGerente" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col">
              <Label type="" label="Nome do gerente" value={this.props.dadosIniciais_nomeGerente} returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>
        <CheckObligation field="dadosIniciais_nomeCompleto" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col">
              <Label type="" label="Nome Completo" value={this.props.dadosIniciais_nomeCompleto} returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>
        <CheckObligation field="dadosIniciais_nomeSocial" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col">
              <Label type="" label="Nome Social" value={this.props.dadosIniciais_nomeSocial} returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>
        <CheckObligation field="dadosIniciais_dataNascimento" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col-50">
              <Label type="" label="Data de Nascimento" value={this.props.dadosIniciais_dataNascimento} returnObject={this.createRefFields} col="50" />
            </div>}
        </CheckObligation>
        <CheckObligation field="dadosIniciais_cpf" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col-50">
              <Label type="" label="CPF" value={this.props.dadosIniciais_cpf} returnObject={this.createRefFields} col="50" />
            </div>}
        </CheckObligation>
        <CheckObligation field="dadosIniciais_tipoDocumento" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col-50">
              <Label type="" label="Documento" value={dadosIniciais_tipoDocumentoNome} returnObject={this.createRefFields} col="50" />
            </div>}
        </CheckObligation>
        <CheckObligation field="dadosIniciais_numeroDocumento" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col-50">
              <Label type="" label="Número do Documento" value={this.props.dadosIniciais_numeroDocumento} returnObject={this.createRefFields} col="50" />
            </div>}
        </CheckObligation>
        <CheckObligation field="dadosIniciais_orgaoEmissor" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col-50">
              <Label type="" label="Órgão Emissor" value={dadosIniciais_orgaoEmissorNome} returnObject={this.createRefFields} col="50" />
            </div>}
        </CheckObligation>
        <CheckObligation field="dadosIniciais_dataEmissao" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col-50">
              <Label type="" label="Data de Emissão" value={this.props.dadosIniciais_dataEmissao} returnObject={this.createRefFields} col="50" />
            </div>}
        </CheckObligation>
        <CheckObligation field="dadosIniciais_paisDocumento" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col-50">
              <Label type="" label="País do Documento" value={dadosIniciais_paisDocumentoNome} returnObject={this.createRefFields} col="50" />
            </div>}
        </CheckObligation>
        <CheckObligation field="dadosIniciais_dataVencimento" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col-50">
              <Label type="" label="Data de Vencimento" value={this.props.dadosIniciais_dataVencimento} returnObject={this.createRefFields} col="50" />
            </div>}
        </CheckObligation>
        <CheckObligation field="dadosIniciais_telefoneCelular" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col">
              <Label type="" label="Telefone Celular"
                value={`${this.props.dadosIniciais_ddiTelefoneCelular.includes("+") ? this.props.dadosIniciais_ddiTelefoneCelular : `+${this.props.dadosIniciais_ddiTelefoneCelular}`} ${this.props.dadosIniciais_telefoneCelular}`}
                returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>
        <CheckObligation field="dadosIniciais_email" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col">
              <Label type="" label="E-mail" value={this.props.dadosIniciais_email} returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>
        {/* ==================================== Dados Iniciais PJ ============================================ */}
        <CheckObligation field="dadosIniciais_razaoSocial" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col">
              <Label type="" label="Razão Social" value={this.props.dadosIniciais_razaoSocial} returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>
        <CheckObligation field="dadosIniciais_cnpj" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col">
              <Label type="" label="CNPJ" value={this.props.dadosIniciais_cnpj} returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>
        <CheckObligation field="dadosIniciais_cnae" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col">
              <Label
                type=""
                label="Atividade da Empresa"
                value={
                  this.props.dadosIniciais_cnae &&
                  this.props.dadosIniciais_cnae.Codigo + " " + this.props.dadosIniciais_cnae.Descricao
                }
                returnObject={this.createRefFields}
              />
            </div>}
        </CheckObligation>
        <CheckObligation field="dadosIniciais_nomeContato" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col">
              <Label type="" label="Nome Completo do Contato" value={this.props.dadosIniciais_nomeContato} returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>
        <CheckObligation field="dadosIniciais_cpfContato" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col-50">
              <Label type="" label="CPF do Contato" value={this.props.dadosIniciais_cpfContato} returnObject={this.createRefFields} col="50" />
            </div>}
        </CheckObligation>
        <CheckObligation field="dadosIniciais_telefoneContato" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col-50">
              <Label type="" label="Telefone Celular"
                value={`${this.props.dadosIniciais_ddiTelefoneContato.includes("+") ? this.props.dadosIniciais_ddiTelefoneContato : `+${this.props.dadosIniciais_ddiTelefoneContato}`} ${this.props.dadosIniciais_telefoneContato}`}
                returnObject={this.createRefFields} col="50" />
            </div>}
        </CheckObligation>
        <CheckObligation field="dadosIniciais_emailContato" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col">
              <Label type="" label="E-mail" value={this.props.dadosIniciais_emailContato} returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>
        {/* ===================================== ENDERECO =========================================== */}
        <div className="col">
          <Label type="title" label="Endereço" />
        </div>
        <CheckObligation field="endereco_pais" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col-50">
              <Label type="" label="País" value={endereco_paisNome} returnObject={this.createRefFields} col="50" />
            </div>}
        </CheckObligation>
        <CheckObligation field="endereco_cep" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col-50">
              <Label type="" label="CEP" value={this.props.endereco_cep} returnObject={this.createRefFields} col="50" />
            </div>}
        </CheckObligation>
        <CheckObligation field="endereco_provincia" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col">
              <Label type="" label="Província" value={this.props.endereco_provincia} returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>
        <CheckObligation field="endereco_estado" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col-50">
              <Label type="" label="Estado" value={endereco_estadoNome} returnObject={this.createRefFields} col="50" />
            </div>}
        </CheckObligation>
        <CheckObligation field="endereco_cidade" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col-50">
              <Label type="" label="Cidade" value={this.props.endereco_cidade} returnObject={this.createRefFields} col="50" />
            </div>}
        </CheckObligation>
        <CheckObligation field="endereco_logradouro" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col">
              <Label type="" label="Logradouro" value={this.props.endereco_logradouro} returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>
        <CheckObligation field="endereco_numero" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col-50">
              <Label type="" label="Número" value={this.props.endereco_numero} returnObject={this.createRefFields} col="50" />
            </div>}
        </CheckObligation>
        <CheckObligation field="endereco_complemento" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col-50">
              <Label type="" label="Complemento" value={this.props.endereco_complemento} returnObject={this.createRefFields} col="50" />
            </div>}
        </CheckObligation>
        <CheckObligation field="endereco_bairro" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col-50">
              <Label type="" label="Bairro" value={this.props.endereco_bairro} returnObject={this.createRefFields} col="50" />
            </div>}
        </CheckObligation>
        <CheckObligation field="endereco_telefoneFixo" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col-50">
              <Label type="" label="Telefone"
                value={this.props.endereco_telefoneFixo !== "" ? `${this.props.endereco_ddiTelefoneFixo.includes("+") ? this.props.endereco_ddiTelefoneFixo : `+${this.props.endereco_ddiTelefoneFixo}`} ${this.props.endereco_telefoneFixo}`
                  : ""}
                returnObject={this.createRefFields} col="50" />
            </div>}
        </CheckObligation>
        {/* ================================================================================ */}
        <div className={`col ${existeDadosComplementares.length !== 1 ? "noVisivel" : ""}`}>
          <Label type="title" label="Dados complementares" />
        </div>
        {/* <CheckObligation field="dadosComplementares_genero" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col-50">
              <Label type="" label="Gênero" value={dadosComplementares_GeneroListNome} returnObject={this.createRefFields} col="50" />
            </div>}
        </CheckObligation> */}
        <CheckObligation field="dadosComplementares_estadoCivil" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col-50">
              <Label type="" label="Estado Civil" value={dadosComplementares_EstadoCivilListNome} returnObject={this.createRefFields} col="50" />
            </div>}
        </CheckObligation>
        <CheckObligation field="dadosComplementares_nomeConjuge" fieldConditional={{ 'dadosComplementares_estadoCivil': dadosComplementares_estadoCivil }}>
          {(validacoes) =>
            <div className="col">
              <Label type="" label="Nome do Cônjuge" value={this.props.dadosComplementares_nomeConjuge} returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>
        <CheckObligation field="dadosComplementares_cpfConjuge" fieldConditional={{ 'dadosComplementares_estadoCivil': dadosComplementares_estadoCivil }}>
          {(validacoes) =>
            <div className="col-50">
              <Label type="" label="CPF do Cônjuge" value={this.props.dadosComplementares_cpfConjuge} returnObject={this.createRefFields} col="50" />
            </div>}
        </CheckObligation>
        <CheckObligation field="dadosComplementares_dataNascimentoConjuge" fieldConditional={{ 'dadosComplementares_estadoCivil': dadosComplementares_estadoCivil }} >
          {(validacoes) =>
            <div className="col-50">
              <Label type="" label="Data Nascimento Cônjuge" value={this.props.dadosComplementares_dataNascimentoConjuge} returnObject={this.createRefFields} col="50" />
            </div>}
        </CheckObligation>
        <CheckObligation field="dadosComplementares_nomeMae" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col">
              <Label type="" label="Nome da Mãe" value={this.props.dadosComplementares_nomeMae} returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>
        <CheckObligation field="dadosComplementares_nomePai" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col">
              <Label type="" label="Nome do Pai" value={this.props.dadosComplementares_nomePai} returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>
        <CheckObligation field="dadosComplementares_pessoaAmericana" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col">
              <Label col="75" type="" label="Possui domicílio fiscal nos Estados Unidos da América, nacionalidade ou cidadania norte-americana ou Green Card?" value={dadosComplementares_pessoaAmericana ? "Sim" : "Não"} returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>
        <CheckObligation field="dadosComplementares_PaisNascimento" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col-50">
              <Label type="" label="País Nascimento" value={dadosComplementares_PaisNascimentoNome} returnObject={this.createRefFields} col="50" />
            </div>}
        </CheckObligation>
        <CheckObligation field="dadosComplementares_SocialSecurityNumber" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col-50">
              <Label type="" label="Social Security Number" value={this.props.dadosComplementares_SocialSecurityNumber} returnObject={this.createRefFields} col="50" />
            </div>}
        </CheckObligation>
        <CheckObligation field="dadosComplementares_paisFiscal" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col-50">
              <Label type="" label="País de Domicílio Fiscal" value={dadosComplementares_PaisFiscalNome} returnObject={this.createRefFields} col="50" />
            </div>}
        </CheckObligation>
        <CheckObligation field="dadosComplementares_NumeroSeguroSocial" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col-50">
              <Label type="" label="Número de Identificação Social" value={this.props.dadosComplementares_NumeroSeguroSocial} returnObject={this.createRefFields} col="50" />
            </div>}
        </CheckObligation>

        {/* ================================================================================ */}
        <div className={`col ${existeDeclaracoesEspecificas.length !== 1 ? "noVisivel" : ""}`}>
          <Label col="75" type="title" label="Declarações Específicas Obrigatórias " />
        </div>
        <CheckObligation field="declaracoesEspecificasObrigatorias_ocupacaoPrincipal" fieldConditional={this.props} >
          {(validacoes) =>
            <div className="col">
              <Label col="75" type="" label="Ocupação Profissional" value={this.props.declaracoesEspecificasObrigatorias_ocupacaoPrincipal} returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>
        <CheckObligation field="declaracoesEspecificasObrigatorias_faixaRendaMensal" fieldConditional={this.props} >
          {(validacoes) =>
            <div className="col">
              <Label col="75" type="" label="Renda Mensal" value={declaracoesEspecificasObrigatorias_rendaMensalRotulo} returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>
        <CheckObligation field="declaracoesEspecificasObrigatorias_faixaPatrimonio" fieldConditional={this.props} >
          {(validacoes) =>
            <div className="col">
              <Label col="75" type="" label="Patrimônio" value={declaracoesEspecificasObrigatorias_patrimonioRotulo} returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>
        <CheckObligation field="declaracoesEspecificasObrigatorias_ppe" fieldConditional={this.props} >
          {(validacoes) =>
            <div className="col">
              <Label col="75" type="" label="Sou pessoa politicamente exposta (PEP) ?" value={declaracoesEspecificasObrigatorias_ppe ? "Sim" : "Não"} returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>
        <CheckObligation field="declaracoesEspecificasObrigatorias_relacaoPessoaPpe" fieldConditional={this.props} >
          {(validacoes) =>
            <div className="col">
              <Label col="75" type="" label="Tenho relacionamento com uma pessoa politicamente exposta (pep) ? " value={declaracoesEspecificasObrigatorias_relacaoPessoaPpe ? "Sim" : "Não"} returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>
        <CheckObligation field="declaracoesEspecificasObrigatorias_socioPpe" fieldConditional={this.props} >
          {(validacoes) =>
            <div className="col">
              <Label col="75" type="" label="Possui em seu quadro Sócio, Administrador ou representante legal pessoa exposta politicamente (PEP) ?" value={declaracoesEspecificasObrigatorias_socioPpe ? "Sim" : "Não"} returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>
        <CheckObligation field="declaracoesEspecificasObrigatorias_participanteFatca" fieldConditional={this.props} >
          {(validacoes) =>
            <div className="col">
              <Label col="75" type="" label="A Empresa é participante da FATCA (Foreign Account Tax Compliance Act) ?" value={declaracoesEspecificasObrigatorias_participanteFatca ? "Sim" : "Não"} returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>
        <CheckObligation field="declaracoesEspecificasObrigatorias_participanteGiin" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col">
              <Label col="75" type="" label="Número do GIIN (Global Intermediary Identification Number)" value={this.props.declaracoesEspecificasObrigatorias_participanteGiin} returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>
        <CheckObligation field="declaracoesEspecificasObrigatorias_pessoaAmericana" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col">
              <Label col="75" type="" label="O Cliente é considerado uma U.S. Person ? " value={declaracoesEspecificasObrigatorias_pessoaAmericana ? "Sim" : "Não"} returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>
        <CheckObligation field="declaracoesEspecificasObrigatorias_nif" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col">
              <Label col="75" type="" label="Número de Identificação Fiscal (NIF/ Tax Identification Number)" value={this.props.declaracoesEspecificasObrigatorias_nif} returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>
        <CheckObligation field="declaracoesEspecificasObrigatorias_nifCountry" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col">
              <Label col="75" type="" label="País do NIF" value={this.props.declaracoesEspecificasObrigatorias_nifCountry} returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>
        <CheckObligation field="declaracoesEspecificasObrigatorias_declaracaoAnual" fieldConditional={this.props}>
          {(validacoes) =>
            <div className="col">
              <Label col="75" type="" label="Autodeclaração de faturamento dos últimos 12 meses" value={declaracoesEspecificas_declaracaoAnualRotulo} returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>

        {/* ======================================== DADOS BANCARIOS ======================================== */}
        <div className={`col ${existeDadosBancarios.length !== 1 ? "noVisivel" : ""}`}>
          <Label type="title" label="Dados bancários" />
        </div>
        <CheckObligation field="dadosBancarios_Banco" fieldConditional={this.props} >
          {(validacoes) =>
            <div className="col">
              <Label type="" label="Banco" value={dadosBancario_BancoListNome} returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>
        <CheckObligation field="dadosBancarios_TipoConta" fieldConditional={this.props} >
          {(validacoes) =>
            <div className="col-50">
              <Label type="" label="Tipo de Conta" value={dadosBancario_TipoContaListNome} returnObject={this.createRefFields} col="50" />
            </div>}
        </CheckObligation>
        <CheckObligation field="dadosBancarios_Agencia" fieldConditional={this.props} >
          {(validacoes) =>
            <div className="col">
              <Label type="" label="Agência" value={this.props.dadosBancario.formDadosBancarios.dadosBancarios_Agencia} returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>
        <CheckObligation field="dadosBancarios_Conta" fieldConditional={this.props} >
          {(validacoes) =>
            <div className="col">
              <Label type="" label="Conta" value={this.props.dadosBancario.formDadosBancarios.dadosBancarios_Conta} returnObject={this.createRefFields} />
            </div>}
        </CheckObligation>

        {/* ================================================================================ */}
        <div>
          <div className="col">
            <Label type="title" label="Documentos em Anexo" />
          </div>
          <Checks itens={itensChecados} fieldConditional={this.props} />
        </div>

        <div className="col">
          <Label type="title" label="Aceite" />
        </div>

        <div className="col contrato-resumo" >
          <CheckBox check={resumo_check1} onChange={handleChangeCheckBox1}></CheckBox>
          <Label col="100" type="" history={this.props.history} url="/contrato" link="Eu li, entendi e concordo com estas regras e condições." />
        </div>

        <div className="col termo-resumo" >
          <p>
            Declaro que, ao ter acesso aos termos de uso de cookies e política de privacidade, 
            manifesto o meu consentimento, por meio da seleção do checkbox correspondente à opção “Li e 
            concordo com os Termos de Uso de Cookies e Políticas de Privacidade”, para o tratamento dos meus dados 
            pessoais de acordo com as finalidades previstas na referida política, na forma da Lei de Proteção de 
            Dados.
          </p>

          <p>
            Declaro ainda estar ciente de que poderei solicitar, a qualquer momento, a revogação do meu 
            consentimento, entretanto, a partir de tal revogação, compreendo que isto poderá restringir, 
            suspender ou cancelar alguns dos serviços ofertados pela B&T Corretora de Câmbio LTDA.
          </p>

          <p>
            De todo modo, a partir do momento da solicitação de exclusão de dados pessoais, a B&T Câmbio o fará 
            dentro do prazo previsto em lei, salvo se o armazenamento dos dados decorrer de obrigação legal.
          </p>
        </div>

        <div className="col termo-resumo-check" >
          <CheckBox check={resumo_check2} onChange={handleChangeCheckBox2}></CheckBox>
          <div className="col">
            Li e concordo com os&nbsp; 
            <a href="https://btcambio.com.br/termos-de-uso/" target="_blank">Termos de Uso de Cookies</a> ,&nbsp; 
            <a href="https://btcambio.com.br/termo-de-adesao-e-concordancia/" target="_blank">Termos de Adesão e Concordância</a> e&nbsp;
            <a href="https://btcambio.com.br/politica-de-privacidade/" target="_blank">Políticas de Privacidade</a>.
          </div>
          {/* <Label col="100" type="" history={this.props.history} url="/termoAceite" link="Li e concordo com os Termos de Uso de Cookies e Políticas de Privacidade." /> */}
        </div>

        <div className="col">
          <NavigationButtons history={this.props.history}
            validateFields={this.validateFields} nextCustomButton={
              <button onClick={postObjCadastroResumoAction} disabled={loadingResumoUpload || !resumo_check1 || !resumo_check2} className={`resumo ${loadingResumoUpload ? "isLoading" : "previous"}`}>{loadingResumoUpload ? "     " : "Enviar"}
                {loadingResumoUpload && <i className="resumo-icon"> <img src={loadingImg} alt="loading" /></i>}
              </button>} />

          {!this.props.conclusao.isError && this.props.conclusao.title && <Redirect to='/conclusao' />}
        </div>
      </section>
    );
  }

  createRefFields = (self) => {
    this.formFields[self.props.name] = self
  }

  validateFields = async () => {
    let list = []

    return new Promise(resolve => {
      for (let key in this.formFields) {
        this.formFields[key].validate(this.formFields[key].input)
          .then(r => {
            list.push({ name: this.formFields[key].props.name, valid: r })
            if (Object.keys(this.formFields).length === list.length)
              resolve(list)
          })
      }
    })
  }
}

export default Resumo;